import { render, staticRenderFns } from "./AddProductToWebsiteTab.vue?vue&type=template&id=85ffdd9e&scoped=true&"
import script from "./AddProductToWebsiteTab.vue?vue&type=script&lang=js&"
export * from "./AddProductToWebsiteTab.vue?vue&type=script&lang=js&"
import style0 from "./AddProductToWebsiteTab.vue?vue&type=style&index=0&id=85ffdd9e&scoped=true&lang=css&"
import style1 from "./AddProductToWebsiteTab.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ffdd9e",
  null
  
)

export default component.exports